import { useCompany } from '../../firebase/auth';
import Resubscribe from './Resubscribe';

export default function Subscription() {
    const { authCompany } = useCompany();
    return <Resubscribe type={authCompany?.subscription?.status}/>
}